import React from 'react'

const AjaxLoaderImg = (props) => {
    const width = props.width ? props.width : '100px'

    return (
        <div className={props.className}>
            <img src='/images/loader-anim-inline.svg' alt='loading...' className='not-ie' style={{ width: width }} />
            <img src='/images/loader-anim-inline-ie.gif' alt='loading...' className='ie' style={{ width: width }} />
        </div>
    )
}

AjaxLoaderImg.defaultProps = {
    className: ''
}

export default AjaxLoaderImg



// WEBPACK FOOTER //
// ./resources/js/components/AjaxLoaderImg.js